import * as Blockly from 'blockly/core';
import { defineMutableBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const COLOR = '#5a9b00';

const CHECK_MAP: Record<string, string> = {
    float: 'Number',
    String: 'String',
    bool: 'Boolean',
};

const SHADOW_MAP: Record<string, { type: string; field: string; value: string | number }> = {
    float: { type: 'number', field: 'NUM', value: 0 },
    String: { type: 'string', field: 'TEXT', value: '' },
    bool: { type: 'bool', field: 'BOOL', value: 'TRUE' },
};

function buildReturnInputs(block: Blockly.Block): void {
    while (block.inputList.length > 0) {
        block.removeInput(block.inputList[0].name ?? '', true);
    }

    const fnName: string = (block as any)._fnName ?? '';
    const returnType: string = (block as any)._returnType ?? 'float';

    const header = block.appendDummyInput('HEADER');
    header.appendField(new (Blockly.FieldImage as any)('/images/block/func.svg', 65, 65, 'icon'));
    header.appendField(new FieldStyledLabel('関数', { fontSize: 12, fontWeight: 'bold' }));
    header.appendField(new FieldStyledBadgeLabel('戻り'));
    header.appendField(new FieldStyledLabel(` ${fnName} を終了して`, {}), 'FN_NAME');

    const shadow = SHADOW_MAP[returnType] ?? SHADOW_MAP['float'];
    const shadowDom = Blockly.utils.xml.createElement('shadow');
    shadowDom.setAttribute('type', shadow.type);
    const shadowField = Blockly.utils.xml.createElement('field');
    shadowField.setAttribute('name', shadow.field);
    shadowField.textContent = String(shadow.value);
    shadowDom.appendChild(shadowField);

    const valueInput = block.appendValueInput('VALUE');
    valueInput.setCheck(CHECK_MAP[returnType] ?? 'Number');
    valueInput.connection?.setShadowDom(shadowDom);

    block.appendDummyInput('SUFFIX').appendField(new FieldStyledLabel('を返す ', {}));
    block.setInputsInline(true);

    if (returnType === 'String') {
        (block as Blockly.BlockSvg).setOutputShape(3);
    } else {
        (block as Blockly.BlockSvg).setOutputShape(0);
    }
}

defineMutableBlock({
    type: 'func_return',
    colour: COLOR,
    tooltip: '関数の戻り値を返します',
    deletable: true,
    movable: true,
    previousStatement: true,

    init(this: Blockly.Block) {
        this.setColour(COLOR);
        this.setTooltip('関数の戻り値を返します');
        this.setMovable(true);
        this.setDeletable(true);
        this.setPreviousStatement(true);
        this.setNextStatement(false);
        (this as any)._fnId = '';
        (this as any)._fnName = '';
        (this as any)._returnType = 'float';
        buildReturnInputs(this);
    },

    mutationToDom(this: Blockly.Block): Element {
        const container = Blockly.utils.xml.createElement('mutation');
        container.setAttribute('fn_id', (this as any)._fnId ?? '');
        container.setAttribute('fn_name', (this as any)._fnName ?? '');
        container.setAttribute('return_type', (this as any)._returnType ?? 'float');
        return container;
    },

    domToMutation(this: Blockly.Block, xml: Element): void {
        (this as any)._fnId = xml.getAttribute('fn_id') ?? '';
        (this as any)._fnName = xml.getAttribute('fn_name') ?? '';
        (this as any)._returnType = xml.getAttribute('return_type') ?? 'float';
        buildReturnInputs(this);
    },
});
